import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Youtube, Instagram, Twitter } from "lucide-react";
import { Container } from "@/components/primitives";
import { GovXLogo } from "@/components/GovXLogo";

const cols = [
  {
    heading: "Practices",
    links: [
      ["Government", "/government"],
      ["Political", "/political"],
      ["Digital", "/digital"],
      ["Impact & Intelligence", "/impact"],
    ],
  },
  {
    heading: "Company",
    links: [
      ["What We Do", "/what-we-do"],
      ["Insights", "/insights"],
      ["Reports", "/reports"],
      ["Partner With Us", "/partner"],
      ["About", "/about"],
      ["Contact", "/contact"],
    ],
  },
];

const socials = [
  { icon: Linkedin, label: "LinkedIn" },
  { icon: Twitter, label: "X" },
  { icon: Youtube, label: "YouTube" },
  { icon: Instagram, label: "Instagram" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-govx-black text-govx-paper grain">
    <Container className="relative z-10 py-16 lg:py-24">
      <div className="grid gap-14 lg:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <GovXLogo variant="light" />
          <p className="mt-6 font-display text-xl font-medium tracking-tight text-govx-paper">
            Governance. Strategy. Delivery.
          </p>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-govx-grey">
            Turning public ambition into measurable impact. We work with governments,
            political organisations and public leaders — from ambition to execution.
          </p>
          <div className="mt-8 flex gap-3">
            {socials.map(({ icon: Icon, label }) => (
              <a
                key={label}
                href="#"
                aria-label={label}
                data-testid={`social-${label.toLowerCase()}`}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/12 text-govx-grey transition-colors duration-300 hover:border-govx-green hover:text-govx-lime"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        {cols.map((col) => (
          <div key={col.heading}>
            <div className="eyebrow text-govx-grey">{col.heading}</div>
            <ul className="mt-6 space-y-3.5">
              {col.links.map(([label, to]) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-sm text-govx-paper/80 transition-colors duration-200 hover:text-govx-lime"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-16 flex flex-col justify-between gap-6 border-t border-white/10 pt-8 text-xs text-govx-grey md:flex-row md:items-center">
        <div className="flex flex-wrap gap-x-6 gap-y-2">
          <span>Privacy Policy</span>
          <span>Data Protection</span>
          <span>Terms</span>
          <span>Conflict of Interest Policy</span>
        </div>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 font-mono">
          <span>contact@govxnigeria.com</span>
          <span>Lagos, Nigeria</span>
          <span>© 2026 GovX Nigeria</span>
        </div>
      </div>
    </Container>
  </footer>
);
